import React from 'react';
import clsx from 'clsx';
import { useStyles } from './style';

const ShimmerLoading = (props) => {
  const classes = useStyles();
  return (
    <>
      <div className={classes.box}>
        <div className={clsx(classes.shimmer, classes.shimmerTitle)} />
      </div>
      <div className={classes.box}>
        <div className={clsx(classes.shimmer, classes.shimmerTitle)} />
      </div>
      <div className={classes.box}>
        <div className={clsx(classes.shimmer, classes.shimmerTitle)} />
      </div>
      <div className={classes.box}>
        <div className={clsx(classes.shimmer, classes.shimmerTitle)} />
      </div>
      <div className={classes.box}>
        <div className={clsx(classes.shimmer, classes.shimmerTitle)} />
      </div>
      <div className={classes.box}>
        <div className={clsx(classes.shimmer, classes.shimmerTitle)} />
      </div>
    </>
  );
};

export default ShimmerLoading;
